import Dexie, { Table } from 'dexie';

import { ReadHistory } from './types';

export class ChatieDatabase extends Dexie {
  readHistory!: Table<ReadHistory>;

  constructor() {
    super('chatieDatabase');
    this.version(1).stores({
      readHistory: 'episodeId, storyId',
    });
  }
}

export const db = new ChatieDatabase();
